import requestAction from '../../utils/requestAction'
import ProductMeasurementType from '../../models/ProductMeasurementType';

export const upsertProductMeasurementType = (productMeasurementType: (ProductMeasurementType)) =>
  requestAction('PRODUCTMEASUREMENTTYPE_UPSERT')(
    `productMeasurementTypes${(productMeasurementType as ProductMeasurementType).id ? `/${(productMeasurementType as ProductMeasurementType).id}` : ''}`,
    (productMeasurementType as ProductMeasurementType).id ? 'PUT' : 'POST',
    productMeasurementType
  )
